<template>
    <button :disabled="loading" :type="type" class="flex items-center">
        <div v-if="loading" class="btn-spinner mr-2"/>
        <slot/>
    </button>
</template>

<script>
export default {
    props: {
        loading: Boolean,
        type: {
            type: String,
            default: 'submit'
        }
    },
}
</script>
